module.exports = __webpack_public_path__ + "static/media/cz.859f18a5.svg";